import { moment } from "../../../../utils/LocalizedUtils";

const TableConfigurator = {
  title: {
    label: "title",
    value: value => (value !== "" ? value : "-"),
  },
  customer: {
    label: "customer",
    value: value => (value !== "" ? value : "-"),
    filterProps: "^[A-Za-z][A-Za-z0-9@.-_]*$",
  },
  // lastContactAt: {
  //   label: "lastContact",
  //   value: value => moment(value - new Date().getTimezoneOffset() * 60000).format("DD.MM - HH:mm"),
  //   toolTip: value => moment(value - new Date().getTimezoneOffset() * 60000).format("LLLL"),
  //   type: "date",
  // },
  // lastContactCustomerAt: {
  //   label: "lastContact",
  //   value: value =>
  //     value !== 0 ? moment(value - new Date().getTimezoneOffset() * 60000).format("DD.MM - HH:mm") : "-",
  //   toolTip: value => (value !== 0 ? moment(value - new Date().getTimezoneOffset() * 60000).format("LLLL") : undefined),
  //   type: "date",
  // },
  sortTimeStamp: {
    label: "lastContact",
    value: value =>
      value !== 0 ? moment(value - new Date().getTimezoneOffset() * 60000).format("DD.MM - HH:mm") : "-",
    toolTip: value => (value !== 0 ? moment(value - new Date().getTimezoneOffset() * 60000).format("LLLL") : undefined),
    type: "date",
  },
  owner: {
    label: "EmailTicketSystemOwner",
    value: value => (value !== "" ? value : "-"),
    filterProps: "^[A-Za-z][A-Za-z0-9@.-_]*$",
  },
  webcastID: {
    label: "webcastID",
    value: value => (value !== "" ? value : "-"),
    onClickSearch: true,
    filterProps: "^[a-zA-Z0-9]{0,12}$",
  },
  orderID: {
    label: "orderID",
    value: value => (value !== "" ? value : "-"),
    onClickSearch: true,
    filterProps: "^[a-zA-Z0-9]{0,8}$",
  },
  externalID: {
    label: "externalId",
    value: value => (value !== "" ? value : "-"),
  },
  operator: {
    label: "operator",
    value: value => (value !== "" ? value : "-"),
    filterProps: "^[A-Za-z][A-Za-z0-9@.-_]*$",
  },
  additionalOperator: {
    label: "additionalOperator",
    value: value => (value !== "" ? value : "-"),
  },
  orderProduct: {
    label: "orderProduct",
    value: value => (value !== "" ? value : "-"),
  },
  // lastUpdatedAt: {
  //   label: "lastUpdateTime",
  //   value: value => moment(value).fromNow(),
  //   toolTip: value => moment(value - new Date().getTimezoneOffset() * 60000).format("LLLL"),
  //   type: "date",
  // },
  // createdBy: {
  //   label: "createdBy",
  //   value: value => (value !== "" ? value : "-"),
  // },
  // createdById: {
  //   label: "createdByID",
  //   value: value => (value !== "" ? value : "-"),
  // },
  // eventEndTime: {
  //   label: "eventEndTime",
  //   value: value => moment(value).fromNow(),
  //   toolTip: value => moment(value - new Date().getTimezoneOffset() * 60000).format("LLLL"),
  //   type: "date",
  // },
  // eventStartTime: {
  //   label: "eventStartTime",
  //   value: value => moment(value).fromNow(),
  //   toolTip: value => moment(value - new Date().getTimezoneOffset() * 60000).format("LLLL"),
  //   type: "date",
  // },
  // group: {
  //   label: "group",
  //   value: value => (value !== "" ? value : "-"),
  // },
  // orderCustomerNo: {
  //   label: "orderCustomerNumber",
  //   value: value => (value !== "" ? value : "-"),
  // },
  // orderStatus: {
  //   label: "orderStatus",
  //   value: value => (value !== "" ? value : "-"),
  // },
  // orderType: {
  //   label: "orderType",
  //   value: value => (value !== "" ? value : "-"),
  // },
  // priority: {
  //   label: "Priority",
  //   value: value => (value !== "" ? value : "-"),
  // },
};

export default TableConfigurator;
